import React from "react";
import "../css/Vaccination.css";
import Review from "./review";

const features = [
  {
    title: "Convenience Without Compromise",
    icon: "⏰",
    points: [
      {
        pointTitle: "Walk-in Access & Extended Hours: ",
        text: "Skip the clinic wait times—come to us when it fits your day."
      },
      {
        pointTitle: "Ideal for Busy Schedules: ",
        text: "No appointment needed—get your flu, COVID-19, or routine vaccines while running errands or picking up prescriptions."
      }
    ]
  },
  {
    title: "Safe, Professional, Patient-Centered Care",
    icon: "🩺",
    points: [
      {
        pointTitle: "Certified Immunizers: ",
        text: "Our pharmacists are certified immunizers who handle vaccines safely—from cold-chain storage to proper administration."
      },
      {
        pointTitle: "Trusted Healthcare Partner: ",
        text: "You're not just a patient—you’re in capable hands. Pharmacists regularly educate and screen for vaccine suitability, boosting protection while reducing hesitation."
      }
    ]
  },
  {
    title: "A Powerful Public Health Resource",
    icon: "🌎",
    points: [
      {
        pointTitle: "Improved Access & Equity: ",
        text: "With easier access and broader hours, community pharmacies help more people get vaccinated, especially those underserved or without easy healthcare access."
      },
      {
        pointTitle: "High Patient Satisfaction: ",
        text: "In global surveys, over 99% of pharmacy vaccine recipients said they'd recommend the service to others."
      }
    ]
  }
];

function VaccinatePage() {
  return (
    <div className="vaccination-page">
      <div className="vaccination-banner">
        <img
          src={'/img_12.179Z.png'}
          alt="Vaccination Banner"
          className="vaccination-banner-img"
        />
        <div className="vaccination-banner-overlay"></div>
        <div className="vaccination-banner-content">
          <h1>Vaccinations </h1>
        </div>
      </div>
      <header className="vaccination-header">
        <h2>Your Health, Protected—Conveniently</h2>
        <p>
          Our vaccination services are designed to deliver both convenience and clinical excellence—because protecting your health should be seamless and reassuring.
        </p>
      </header>
      <div className="vaccination-cards">
        {features.map((feature, idx) => (
          <div className="vaccination-card" key={idx}>
            <div className="vaccination-icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <ul>
              {feature.points.map((point, i) => (
                <li  key={i}><strong>{point.pointTitle}</strong>{point.text}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="vaccination-benefits-card">
        <h4>Why Choose Us?</h4>
        <ul>
          <li>
            <strong>Flexible walk-in access</strong> and extended hours for busy lives.
          </li>
          <li>
            <strong>Expert care</strong> from certified immunizers.
          </li>
          <li>
            <strong>Trusted by the community</strong>—over 99% of patients recommend our service.
          </li>
        </ul>
        <p>
          Whether you're due for a flu shot, COVID-19 booster, or other essential immunization, we're here for you—no fuss, just quality care.
        </p>
      </div>
       <Review/>
    </div>
  );
}

export default VaccinatePage;